import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { Variant } from '@material-ui/core/styles/createTypography';
import Typography from '@material-ui/core/Typography';
import React, { useState } from 'react';
import { IFormContext } from 'rewire-ui';
import { Observe } from 'rewire-core';
import inviteDialogModel from '../side-navigation/InviteDialogModel';
import { EmployeeDialogModel } from '../schedule/EmployeeDialogModel';
import queries from '../graphql/Queries';
import Icon from '@material-ui/core/Icon';

export function createTitle(form: IFormContext, title: string, className: string = '', variant: Variant = 'h6') {
  return form.custom(() => (
    <Typography variant={variant} className={className}>
      {title}
    </Typography>
  ));
}

export function _Button({
  title,
  onClick,
  className,
  onDisabled,
}: {
  title: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  onDisabled?: () => boolean;
}) {
  return (
    <Observe>
      {() => (
        <Button className={className} title={title} color="primary" variant="contained" disabled={onDisabled?.()} onClick={onClick}>
          {title}
        </Button>
      )}
    </Observe>
  );
}

export function createButton(
  form: IFormContext,
  title: string,
  onClick: React.MouseEventHandler<HTMLButtonElement>,
  className: string = 'span1',
  onDisabled?: () => boolean,
) {
  return form.custom(() => <_Button title={title} onClick={onClick} className={className} onDisabled={onDisabled} />);
}

export function divider(form: IFormContext) {
  return form.custom(() => <Divider />);
}

export function createCustom<T>(
  form: IFormContext,
  fn: () => Promise<T>,
  Render: React.ComponentType<{ form: IFormContext; item?: T }>,
) {
  return form
    .custom(() => {
      const [item, setItem] = useState<T>();
      React.useEffect(() => {
        const fetch = async () => {
          setItem(await fn());
        };
        fetch();
      }, []);
      return <Render form={form} item={item} />;
    })
    .accessor(
      (o) => '',
      (_o, _v) => {},
    );
}

export function createInviteForMobile(dialog: EmployeeDialogModel, form: IFormContext) {
  const onClick = () => {
    inviteDialogModel.load();
    inviteDialogModel.form.setFieldValue('email', dialog.form.field.email.value);
    inviteDialogModel.form.setFieldValue('role', { id: 'employee', code: 'employee', name: 'Employee' });
    const employee = dialog.form.toObjectValues();
    employee.id = dialog.id;
    inviteDialogModel.form.setFieldValue('employee', employee);
  };

  const disabled = () => dialog.isNew || !dialog.form.field.email.value;
  const doesEmployeeHaveMobileAccess = async () => {
    const email = dialog.form.field.email.value;
    if (!email) return null;
    const result = await queries.hasEmployeeMobileAccess(email);
    if (typeof result === 'boolean') return result;
    return null;
  };

  return createCustom<any>(form, doesEmployeeHaveMobileAccess, ({ item }) => {
    console.log('item', item);
    if (typeof item !== 'boolean') return null;
    if (item === true) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Icon style={{ color: 'green' }} className="mobile_friendly">
            {'mobile_friendly'}
          </Icon>
          <Typography variant="subtitle1" style={{ color: 'green' }}>
            Has Mobile Access
          </Typography>
        </div>
      );
    }
    return <_Button title="Invite To Mobile" onClick={onClick} className="span1" onDisabled={disabled} />;
    // return <_Button title="Invite To Mobile" onClick={onClick} className="span1" onDisabled={() => disabled(item)} />;
  });
}
